import api from './index'

export async function getScriptsAndRebuttalsObject(
  token: string,
): Promise<{ APIScriptsCopy: object; APIRebuttalsCopy: object }> {
  try {
    const res = await api.get('/agent/rebuttals', {
      headers: { Authorization: `Bearer ${token}` },
    })

    if (res.status !== 200) {
      throw new Error(`Non-200 status: ${res.status}`)
    }

    const allRebuttals = res.data.data.rebuttals ?? []
    const allScripts = res.data.data.scripts ?? []

    const returnScripts = {} as Record<string, object>
    const returnRebuttals = {} as Record<string, object>

    //@ts-ignore
    allScripts.forEach((script) => {
      returnScripts[script.slug] = {}
      //@ts-ignore
      script.contents?.forEach((c) => {
        //@ts-ignore
        returnScripts[script.slug][c.title] = {
          disabled: c.disabled,
          order: c.ordinal,
          fileContent: c.content,
          title: c.title,
          id: c.id,
          slug: c.slug,
        }
      })
    })

    //@ts-ignore
    allRebuttals.forEach((reb) => {
      returnRebuttals[reb.slug] = {}
      //@ts-ignore
      reb.contents?.forEach((c) => {
        //@ts-ignore
        returnRebuttals[reb.slug][c.title] = {
          disabled: c.disabled,
          order: c.ordinal,
          fileContent: c.content,
          title: c.title,
          id: c.id,
          slug: c.slug,
        }
      })
    })

    return { APIScriptsCopy: returnScripts, APIRebuttalsCopy: returnRebuttals }
  } catch (err) {
    console.error('getScriptsAndRebuttalsObject failed:', err)
    return { APIScriptsCopy: {}, APIRebuttalsCopy: {} }
  }
}

export async function getRebuttalHash(token: string): Promise<string> {
  const checksumPromise = await api
    .get('/agent/rebuttals/checksum', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch(() => {
      console.warn('Error communicating with module-manager api')
    })

  if (checksumPromise && checksumPromise.status === 200) {
    return checksumPromise.data.data.checksum
  }

  return ''
}

export async function updateScriptAPICall(
  isScripts: boolean,
  token: string,
  contentSlug: string,
  scriptName: string,
  objectSlug: string,
  updatedText: string,
): Promise<void> {
  await api
    .put(
      `/agent/${isScripts ? 'scripts' : 'rebuttals'}/${objectSlug}/content/${contentSlug}`,
      {
        name: scriptName,
        slug: objectSlug,
        content: updatedText,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .catch(() => {
      console.warn('Error communicating with module-manager api (Update)')
    })
}
